const OrderNoteList = ({ notes }) => {
  if (notes.length === 0) return null

  const noteList = notes?.slice()?.reverse()
  return (
    <li>
      <div className="d-flex w-100 justify-content-between mt-2">
        <label className="d-flex mb-0" style={{ width: '210px', minWidth: '210px' }}>
          ประวัติโน้ต :
        </label>
        <div>
          {noteList?.map((note, index) => {
            const updateDate = new Date(note.createdAt).toLocaleString('TH-th')
            return (
              <div key={index}>
                {note.text} ({updateDate} น.)
              </div>
            )
          })}
        </div>
      </div>
    </li>
  )
}

export default OrderNoteList
